
import "../assets/css/maintenance.css";
import openBetaLogo from "../assets/images/home/onepeople-open-beta-logo.svg";

function Maintenance() {
    return (
        <>
            <div className="header">
                <div className="left-nav">
                    <a href="/">
                        <img
                            src={openBetaLogo}
                            alt="OnePeopleOnline Logo"
                            className="header-logo bounce"
                        />
                    </a>
                </div>
            </div>

            <div id="maintenance_container">
                <div id="maintenance_info_container">
                    <h1 id="maintenance_msg1">Reticulating<br></br>Splines</h1>
                    <h4 id="maintenance_msg2" className="mt-4 mt-md-5">OnePeople.online is under maintenance.</h4>
                    <p id="maintenance_msg3" className="mt-3 mt-md-4">We'll be back soon.</p>    
                </div>
            </div>

        </>

    )
}

export default Maintenance;